export default {"src":"https://fishbrain.com/_next/static/media/secondPlace.53d904c0.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};